import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { SpotlightTypeResources } from 'services/resources/catalogs/spotlight-type';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const SpotlightTypePage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(SpotlightTypeResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.spotlight-type.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} hasCode m={8} />
    </>
  );
};
